import { APICore } from '../helpers/api/apiCore';
import { findObject } from '../utils/AllFunction';
import { apiReturnCallBack } from './ApiConfig';
import apiContainer from './apiContainer';
const api = new APICore();

const Collections = apiContainer.Collections
//GET--->
// Corrected getCollections function
export async function getCollectionsApi(request) {
    let findObj = findObject(request);
    try {
        return api.get(`${Collections}`, findObj);
    } catch (error) {
        console.error('Fetch error:', error);
        throw error;
    }
}

export async function getCollectionsReportApi(request) {
    let findObj = findObject(request);
    try {
        return api.get(`/report${Collections}`, findObj);
    } catch (error) {
        console.error('Fetch error:', error);
        throw error;
    }
}

export async function getCollectionsUsersReportApi(request) {
    let findObj = findObject(request);
    try {
        return api.get(`/report${Collections}/${request.route}`, findObj);
    } catch (error) {
        console.error('Fetch error:', error);
        throw error;
    }
}

//CREATE---->
export async function createCollections(request) {
    try {
        return api.create(`${Collections}`, request);
    } catch (error) {
        console.error('Fetch error:', error);
        throw error;
    }
}
//UPDATE---->
export async function updateCollections(request, CollectionsId) {
    try {
        return api.update(`${Collections}/${CollectionsId}`, request);
    } catch (error) {
        console.error('Fetch error:', error);
        throw error;
    }
}
//DELETE---->
export async function deleteCollections(CollectionsId) {
    try {
        return api.delete(`${Collections}/${CollectionsId}`);
    } catch (error) {
        console.error('Fetch error:', error);
        throw error;
    }
}



